'use strict'

export default {
  namespaced: true,
  state() {
    return {
      errorId: null,
      error: null
    }
  },

  getters: {
    error (state, getters) {
      return state.error;
    },

    error_id (state, getters) {
      return state.errorId;
    }
  },

  actions: {
    setError ({commit}, err) {
      commit('setError', typeof err === 'object' ? err.message : err)
      if (typeof err === 'object') {
        commit('setErrorId', err.id)
      }
    }
  },

  mutations: {
    setError (state, err) {
      state.error = err
    },
    clearError (state) {
      state.error = null
    },
    setErrorId (state, id) {
      state.errorId = id
    }
  }
}
